import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=fef06b6c&scoped=true"
import script from "./CampaignReport.vue?vue&type=script&lang=js"
export * from "./CampaignReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef06b6c",
  null
  
)

export default component.exports